import { css } from '@huspy/styled-system/css';

export const content = css({ borderRadius: 'radius-4' });
